import { render, staticRenderFns } from "./shenbaoShouYe.vue?vue&type=template&id=b265b542&scoped=true&"
import script from "./shenbaoShouYe.vue?vue&type=script&lang=js&"
export * from "./shenbaoShouYe.vue?vue&type=script&lang=js&"
import style0 from "./shenbaoShouYe.vue?vue&type=style&index=0&id=b265b542&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b265b542",
  null
  
)

export default component.exports